import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  add_parent_blog_category,
  update_parent_blog_category,
} from "../../../data/ApiEndpoints";
import { showConfirmAlert } from "../../components-react/ReactAlert";

function validateBlogCategoriesForm(formValues) {
  let errors = {};

  if (!formValues.categoryName) {
    errors.categoryName = "blog category name required!";
  } else if (formValues.categoryName.length > 100) {
    errors.categoryName =
      "Blog category name cannot be greater than 100 characters!";
  } else if (/[^a-zA-Z0-9 ]/.test(formValues.categoryName)) {
    errors.categoryName =
      "Blog category name must not contain special characters!";
  }

  return errors;
}

const ParentCategoryForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const iniFormvalues = {
    categoryName: isEdit && rowData?.name ? rowData.name : "",
    isActive: isEdit && rowData?.status ? true : false,
  };
  const [formValues, setFormValues] = useState(iniFormvalues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateBlogCategoriesForm(formValues));
    setIsSubmit(true);
  };

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit
      ? update_parent_blog_category
      : add_parent_blog_category;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.categoryName || "",
        status: formValues.isActive ? 1 : 0,
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `${isEdit ? "Update" : "Add"} Blog Category`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title="Manage Blog Parent Categories"
        btnTxt={isEdit ? "Update" : "Submit"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="categoryName" className={`formInputLabel `}>
              blog parent category Name
              <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Blog Parent Category Name"
              className={`formInput ${
                formErrors?.categoryName ? "formError" : ""
              }`}
              name="categoryName"
              value={formValues.categoryName}
              onChange={onChangeInput}
            />

            {formErrors?.categoryName && (
              <span className="error-label">
                {formErrors.categoryName || ""}
              </span>
            )}
          </div>
        </div>

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive ? "formError" : ""
              }`}
            >
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ParentCategoryForm;
